module.exports = __webpack_public_path__ + "img/W-AS-12A.c094c93f.jpg";